module.exports = __webpack_public_path__ + "img/goods7_3.969aa865.jpg";